<template>
	<v-modal>
		<template v-slot:header>
			<h1>Health Status</h1>
		</template>

		<!--			<header>-->
		<!--				<h1 class="beta heavy" v-html="alertGroupIndex"/>-->
		<!--			</header>-->
		<ul class="flex flex-col gap-1">
			<template v-for="(alertGroup, alertGroupIndex) in alerts">
				<li
					v-for="(alert, alertIndex) in alertGroup" :key="alertGroupIndex + alertIndex"
					class="flex gap-1 items-center">
					<span class="icon" :class="alertClass(alert)">&nbsp;</span>
					<span class="beta" v-html="alert.message"/>
				</li>
			</template>
		</ul>
	</v-modal>
</template>
<script>

export default {
	methods: {
		alertClass(alert = null) {
			let classes = {};
			classes["icon--alert--" + alert.severity] = true;
			return classes;
		},
	},

	props: {
		alerts: {
			required: true,
			type: Object,
		},
	},
};
</script>
